import { Link } from 'react-router-dom';
import { Card, CardTitle, Icon } from '../ui';

/**
 * The assistant, as a home card — a teaser that opens the full "Ask anything" panel
 * at /ask. It fetches nothing and keeps no state: one tap and you're in the real
 * thing. Safe on every home, kids included — Ask is explicitly for the whole family
 * (src/modules/assistant/AskPanel.tsx), and this card only ever links there.
 */
const EXAMPLES = [
  'A rainy-day activity',
  'Dinner from what we have',
  'Explain it simply',
];

export default function AskCard() {
  return (
    <Card className="h-full">
      <div className="flex h-full flex-col p-5">
        <CardTitle icon="pulse" action={{ to: '/ask', label: 'Open' }}>
          Ask
        </CardTitle>

        <p className="mt-4 text-sm leading-relaxed text-ink-soft">
          Homework help, dinner ideas, a plan for the weekend — the whole family can ask.
        </p>

        <div className="mt-4 flex flex-wrap gap-2">
          {EXAMPLES.map((ex) => (
            <Link
              key={ex}
              to="/ask"
              className="inline-flex min-h-9 items-center rounded-full border border-border bg-surface-sunk px-3 text-xs font-medium text-ink-soft transition-colors hover:text-ink focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sage"
            >
              {ex}
            </Link>
          ))}
        </div>

        <Link
          to="/ask"
          className="mt-auto inline-flex min-h-11 items-center gap-1.5 self-start rounded-full bg-sage px-4 text-sm font-medium text-white transition-colors hover:bg-sage/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sage"
        >
          Ask anything
          <Icon name="arrow" className="h-4 w-4" />
        </Link>
      </div>
    </Card>
  );
}
